import React from 'react';
import PropTypes from 'prop-types';
import includes from 'lodash/includes';
import { parseFollowSignal } from '@eb/event-renderer';

import {
    GRID_TYPE,
    STANDARD_STYLE,
    IMAGE_STYLE_FIXED,
    TYPES_PROP_TYPE,
    STYLES_PROP_TYPE,
    IMAGE_STYLES_PROP_TYPE,
} from '@eb/eds-media-card-content';
import { EventCard, CONSUMER_CARD_DEFAULTS } from '@eb/event-renderer';
import { getLocationInfo } from '../../utils/venue';
import SearchEventCardDebugInfo from './SearchEventCardDebugInfo';
import ExpandDedupedEventCTA from './ExpandDedupedEventCTA';

import {
    CITY_BROWSE_SECTION,
    SEARCH_SECTION,
    GA_VIEW_EVENT_ACTION,
    GA_CATEGORY_MAP,
    GA_EXTERNAL_VIEW_EVENT_ACTION,
} from '../../constants/analytics';

import {
    EVENTBRITE,
    EVENT_PROPTYPES,
    LINK_FOLLOW_ALLOWLIST,
} from '../../constants';
export class SearchEventCard extends React.PureComponent {
    static propTypes = {
        ...EVENT_PROPTYPES,
        containerSpacingClasses: PropTypes.string,
        edgeColor: PropTypes.string,
        hideStartDate: PropTypes.bool,
        imageStyle: IMAGE_STYLES_PROP_TYPE,
        isAuthenticated: PropTypes.bool,
        isOnlineEvent: PropTypes.bool,
        position: PropTypes.number,
        section: PropTypes.oneOf([CITY_BROWSE_SECTION, SEARCH_SECTION]),
        style: STYLES_PROP_TYPE,
        trackClickInternal: PropTypes.func,
        type: TYPES_PROP_TYPE,
    };

    static defaultProps = {
        style: STANDARD_STYLE,
        type: GRID_TYPE,
        imageStyle: IMAGE_STYLE_FIXED,
        // eslint-disable-next-line react/default-props-match-prop-types
        venueName: '',
        // eslint-disable-next-line react/default-props-match-prop-types
        venueAddress: '',
        section: CITY_BROWSE_SECTION,
    };

    _handleEventClick = () => {
        const {
            id,
            trackClick,
            ticketsBy,
            trackClickInternal,
            numFollowers,
        } = this.props;

        if (trackClick) {
            const actionType =
                ticketsBy === EVENTBRITE
                    ? GA_VIEW_EVENT_ACTION
                    : GA_EXTERNAL_VIEW_EVENT_ACTION;

            trackClick(actionType, numFollowers);
        }

        if (trackClickInternal) {
            trackClickInternal(id, ticketsBy);
        }
    };

    render() {
        let {
            containerSpacingClasses,
            debugInfo,
            dedup,
            edgeColor,
            eventSalesStatus,
            experiments,
            focused,
            hideStartDate,
            history,
            id,
            imageStyle,
            imageUrl,
            isAuthenticated,
            isFree,
            isOnlineEvent,
            isSoldOut,
            minPrice,
            name,
            position,
            organizerName,
            repeatingInstanceCount,
            savedByYou,
            section,
            seriesUrl,
            shouldShowDebugOutput,
            startDate,
            startTime,
            style,
            ticketsBy,
            timezone,
            type,
            url,
            venueAddress,
            venueName,
            numFollowers,
        } = this.props;

        const locationInfo = getLocationInfo(venueName, venueAddress);

        let priceInfo;

        /* We want to default the cards on search pages to not include the
        extra content unless explicitly passed through */
        if (section === SEARCH_SECTION) {
            // On search event cards we want price information
            priceInfo = minPrice;
        }

        // Since we currently noindex children events,
        // we link their event cards to the parent event page (which is indexed)
        // so that parent events can be crawled.
        // See https://jira.evbhome.com/browse/EB-109015
        if (seriesUrl) {
            url = seriesUrl;
        }

        const shouldShowExpandDedupedEventCTA =
            dedup && typeof dedup.count === 'number' && dedup.count > 1;

        const signal = parseFollowSignal(numFollowers);

        return (
            <div
                className="search-event-card eds-l-mar-vert-1"
                ref={this.myRef}
            >
                <EventCard
                    {...CONSUMER_CARD_DEFAULTS}
                    {...signal}
                    containerSpacingClasses={containerSpacingClasses}
                    eventData={{
                        edgeColor,
                        id,
                        imageUrl,
                        isFree,
                        isOnlineEvent,
                        isSoldOut,
                        locationInfo,
                        minPrice: priceInfo,
                        name,
                        organizerName,
                        organizerFollowerCount: numFollowers,
                        repeatingInstanceCount,
                        savedByYou,
                        startDate: hideStartDate ? null : startDate,
                        startTime: startTime || null,
                        timezone: hideStartDate ? null : timezone,
                        url,
                    }}
                    onClick={this._handleEventClick}
                    gaCategory={GA_CATEGORY_MAP[section]}
                    isAuthenticated={isAuthenticated}
                    isTargetBlank={true}
                    eventSalesStatus={eventSalesStatus}
                    experiments={experiments}
                    focused={focused}
                    imageStyle={imageStyle}
                    isNoFollow={!includes(LINK_FOLLOW_ALLOWLIST, ticketsBy)}
                    style={style}
                    type={type}
                />
                {shouldShowExpandDedupedEventCTA && (
                    <ExpandDedupedEventCTA
                        dedup={dedup}
                        history={history}
                        name={name}
                        eventId={id}
                    />
                )}
                {debugInfo &&
                    debugInfo.esDebugInfo &&
                    shouldShowDebugOutput && (
                        <SearchEventCardDebugInfo
                            debugInfo={debugInfo}
                            position={position}
                            numFollowers={numFollowers}
                        />
                    )}
            </div>
        );
    }
}
export default SearchEventCard;
